import type { BreakpointNames } from '@workramp/ui';
import { useTheme } from 'styled-components';
import { useEffect, useState } from 'react';
import { useMediaQuery } from './useMediaQuery';

export const useViewportBreakpoint = () => {
  const [viewPortBreakpoint, setViewportBreakpoint] = useState<BreakpointNames>('xs');
  const theme = useTheme();
  const isSmAndUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdAndUp = useMediaQuery(theme.breakpoints.up('md'));
  const isLgAndUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isXlAndUp = useMediaQuery(theme.breakpoints.up('xl'));

  useEffect(() => {
    if (isXlAndUp) {
      return setViewportBreakpoint('xl');
    }
    if (isLgAndUp) {
      return setViewportBreakpoint('lg');
    }
    if (isMdAndUp) {
      return setViewportBreakpoint('md');
    }
    if (isSmAndUp) {
      return setViewportBreakpoint('sm');
    }
    // else, screen is xs
    return setViewportBreakpoint('xs');
  }, [isXlAndUp, isLgAndUp, isMdAndUp, isSmAndUp]);
  return viewPortBreakpoint;
};
